module.exports = __webpack_public_path__ + "static/media/image-stabilization-endurance@2x.79ba3e8f.png";